export function hasPermission({ key, permissionKeys }) {
  if (!key || !permissionKeys) {
    throw new Error('key 与 permissionKeys 是必传参数')
  }
  return permissionKeys.some(item => item === key)
}
